module.exports = __webpack_public_path__ + "static/media/promo-rasa-bord.e6018b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-rasa-bord.jpg
// module id = 317
// module chunks = 0